import React, { FC } from "react";
import { FacebookRounded, Instagram, X } from "@mui/icons-material";
import { Footer, FooterProps } from "@plataformaxvia/design-system";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

const RoutesCatalog = {
  HOME_PAGE: "/",
  DEPARTMENT_LIST_PAGE: "/secretarias-e-orgaos",
  SERVICE_LIST_PAGE: "/carta-de-servicos",
  NEWS_PAGE: "/noticias",
  SITE_MAP_PAGE: "/mapa-do-site",
};

export const FooterContainer: FC = () => {
  const props: FooterProps = {
    socialMediaLinks: [
      {
        Icon: FacebookRounded as React.FC,
        link: "https://www.facebook.com/governope/",
      },
      {
        Icon: X as React.FC,
        link: "https://x.com/governope?mx=2",
      },
      {
        Icon: Instagram as React.FC,
        link: "https://www.instagram.com/governope/",
      },
    ],
    internalLinks: [
      {
        text: "Início",
        link: `/app/catalog${RoutesCatalog.HOME_PAGE}`,
      },
      {
        text: "Serviços",
        link: `/app/catalog${RoutesCatalog.SERVICE_LIST_PAGE}`,
      },
      {
        text: "Notícias",
        link: `/app/catalog${RoutesCatalog.NEWS_PAGE}`,
      },
      {
        text: "Governo",
        link: `/app/catalog${RoutesCatalog.DEPARTMENT_LIST_PAGE}`,
      },
      {
        text: "Mapa do Site",
        link: `/app/catalog${RoutesCatalog.SITE_MAP_PAGE}`,
      },
      {
        text: "Privacidade",
        link: `/politicas-de-privacidade`,
      },
    ],
    externalLinks: [
      {
        text: "Diário Oficial",
        link: "https://diariooficial.cepe.com.br/diariooficialweb/#/home?diario=MQ%3D%3D",
      },
      {
        text: "Ouvidoria",
        link: "https://ouve.pe.gov.br/modalidades",
      },
      {
        text: "Transparência",
        link: "https://transparencia.pe.gov.br/",
      },
      {
        text: "Licitações",
        link: "https://www.peintegrado.pe.gov.br/Default.aspx",
      },
    ],
    contacts: [
      {
        text: "+55 81 3181.2100",
        link: "tel:+558131812100",
        Icon: LocalPhoneIcon as React.FC,
      },
      {
        text: "servicocidadao@sad.pe.gov.br",
        link: "mailto:servicocidadao@sad.pe.gov.br",
        Icon: EmailIcon as React.FC,
      },
      {
        text: "Praça da República, Bairro de Santo Antônio, Recife - PE, CEP 50.010-928",
        link: "https://www.google.com.br/maps/place/pra%c3%a7a+da+rep%c3%bablica+-+santo+ant%c3%b4nio,+recife+-+pe",
        Icon: FmdGoodIcon as React.FC,
        target: "_blank",
      },
    ],
  };

  return <Footer {...props} />;
};
